import {
  isInAction,
  isInBatch,
  isInUnbatch,
  isInUndispatch,
  isInUntrack
} from './lambdas'
import { suspendUntrack, unbatch } from './signal'
import { suspendUndispatch, undispatch } from './undispatch'

export const __REHAJE_REACTIVE_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE =
  {
    isInAction,
    isInBatch,
    isInUnbatch,
    isInUndispatch,
    isInUntrack,
    suspendUndispatch,
    suspendUntrack,
    unbatch,
    undispatch
  }
